import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { useLocation } from 'react-router-dom';
import useAxios from '../utils/useAxios';
import { usePresetStore } from '../components/datastore.js';

const CATEGORIES = [
    { value: 'bug', label: 'Bug' },
    { value: 'idea', label: 'Idea' },
    { value: 'confusing', label: 'Confusing' },
    { value: 'other', label: 'Something else' },
];

const FeedbackForm = ({ onClose }) => {
    const api = useAxios();
    const location = useLocation();
    const planId = usePresetStore((state) => state.planId);

    const [category, setCategory] = useState('');
    const [message, setMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    useEffect(() => {
        if (!sent) return;
        const timer = setTimeout(onClose, 2000);
        return () => clearTimeout(timer);
    }, [sent, onClose]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!message.trim()) {
            setErrorMessage('Enter your feedback first');
            return;
        }
        setErrorMessage('');
        setLoading(true);
        try {
            await api.post('/feedback/', {
                category,
                message: message.trim(),
                page: location.pathname,
                plan_id: planId || null,
            });
            setSent(true);
        } catch (error) {
            setErrorMessage('Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    if (sent) {
        return (
            <section>
                <p className="small" style={{ marginBottom: 0 }}>Thank you for providing feedback. We appreciate it.</p>
            </section>
        );
    }

    return (
        <section>
            <Form onSubmit={handleSubmit}>
                <div className="feedback-chip-row">
                    {CATEGORIES.map((c) => (
                        <button
                            type="button"
                            key={c.value}
                            className={`feedback-chip${category === c.value ? ' active' : ''}`}
                            onClick={() => setCategory(category === c.value ? '' : c.value)}
                        >
                            {c.label}
                        </button>
                    ))}
                </div>

                <Form.Group style={{ marginBottom: '14px' }}>
                    <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder="What's on your mind?"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        autoFocus
                    />
                </Form.Group>

                {errorMessage && (
                    <div style={{ color: 'red', marginTop: '10px' }}>
                        {errorMessage}
                    </div>
                )}

                <div style={{ textAlign: 'right' }}>
                    <Button variant="secondary" onClick={onClose} className="me-2" disabled={loading}>Cancel</Button>
                    <Button variant="success" type="submit" disabled={loading}>
                        {loading ? 'Sending…' : 'Send feedback'}
                    </Button>
                </div>
            </Form>
        </section>
    );
};

export default FeedbackForm;
